import { Client } from '@src/common/services/Client';

export interface ConfirmResetPasswordRequest {
  resetPasswordAttemptCode: string;
  newPassword: string;
  userEmail: string;
}

export interface ChangePasswordRequest {
  newPassword: string;
  userEmail: string;
}

export const PasswordManagementClient = {
  changePassword: async (request: ChangePasswordRequest) => {
    await Client.post('/change-password', request, {
      withCredentials: true,
    });
  },
  confirmResetPassword: async (request: ConfirmResetPasswordRequest) => {
    await Client.post('/confirm-reset-password', request);
  },
};
